// extracted by mini-css-extract-plugin
export default {"hero":"SectionHero_hero__XTv7t","heroTitle":"SectionHero_heroTitle__Q9cXd","heroImgBottom":"SectionHero_heroImgBottom__03PDK"};